import WebsiteBehaviors from "../website-behaviors/index.js";

class ReadCube extends WebsiteBehaviors {
	identifier() {
		return "ReadCube";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return (location.host === "www.readcube.com");
	}

	// @ts-expect-error TODO
	mouseDown(event, bypassHighlightRules) {
		// Disable their popup

		// 2022-06-08 Jinghan:
		// In the process of removing jQuery, there doesn't seem to be anything
		// equivalent to $._data(document, "events"), where you could browse and
		// selectively remove one event handler that can be done in plain JS.
		//
		// The following call prevents any remaining mousedown listeners from
		// being called, theoretically including the one that opens the ReadCube
		// popup. It may also prevent other wanted handlers from being called.
		//
		// At this time, the login for ReadCube isn't working. The last time I
		// remember being able to log in, I don't believe the implementation was
		// working either. So this may not being doing anything useful.
		event.stopImmediatePropagation();
	}

	shouldFrameTakeControl() {
		return true;
	}

	styles() {
		// language=CSS
		return `
			.aa-highlight {
				background-color: rgba(255,255,0,.2);
			}
		`;
	}
}

export default ReadCube;
